import {combineReducers} from 'redux';

import recordsReducer from './recordsSlice';

const entityKey = 'credentials';

const stateReducer = combineReducers({
    records: recordsReducer,
});

export default stateReducer;
